import React from "react";

import { yaml } from "@codemirror/lang-yaml";
import { oneDark } from "@codemirror/theme-one-dark";
import { Box, useTheme } from "@mui/material";
import CodeMirror from "@uiw/react-codemirror";

interface ManifestYamlViewerProps {
  yamlContent: string;
}

export function ManifestYamlViewer({
  yamlContent,
}: ManifestYamlViewerProps): React.ReactElement {
  const theme = useTheme();

  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
        overflow: "hidden",
        "& .cm-editor": {
          fontSize: "0.8125rem",
          maxHeight: 600,
        },
        "& .cm-scroller": {
          maxHeight: 600,
          overflow: "auto",
        },
      }}
    >
      <CodeMirror
        value={yamlContent}
        extensions={[yaml()]}
        theme={theme.palette.mode === "dark" ? oneDark : undefined}
        editable={false}
        readOnly={true}
        basicSetup={{
          lineNumbers: true,
          foldGutter: true,
          highlightActiveLine: true,
          bracketMatching: true,
          indentOnInput: false,
        }}
      />
    </Box>
  );
}

export default ManifestYamlViewer;
